module.exports = __webpack_public_path__ + "img/canvas_bg0.37d303e7.png";